import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';

@Component({
  selector: 'app-user-service',
  templateUrl: './user-service.component.html',
  styleUrls: ['./user-service.component.scss']
})
export class UserServiceComponent implements OnInit {
  public userId :any
  public services : any
  public expandedDescriptions: { [key: string]: boolean } = {};
  isDropdownVisible: { [id: string]: boolean } = {};

  constructor(
    private activatedRoute: ActivatedRoute , 
    private apiService : ApisService,
    private router: Router , 
    private loading : LoadingService
  ) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      this.userId= params['id'];
    })
    this.getServices()
  }


/*----------  Get Service by userId  ----------*/
getServices() { 
  this.loading.show()
  this.apiService.serviceByUserId(this.userId).subscribe({
    next: (response: any) => {
      this.loading.hide()
      this.services = response.data?.items
      console.log("response" , response);
    }, 
    error(err) {
      this.loading.hide()
      console.log("error in fetching data", err);
    },
  })
}

goToServiceDetails(serviceId: number) {
  this.router.navigate(['/service-details', serviceId]);
}


/*----------  Toggling description  ----------*/
toggleDescription(serviceId: string): void {
  this.expandedDescriptions[serviceId] = !this.expandedDescriptions[serviceId];
}

isExpanded(serviceId: string): boolean {
  return !!this.expandedDescriptions[serviceId];
}
  

/*----------  suspend Service  ----------*/
suspendService(serviceId:any , data :any) { 
  this.apiService.suspendService(serviceId).subscribe({
    next: (response: any) => {
      console.log("response" , response);
      this.getServices();
    }, 
    error(err) {
      console.log("error in fetching data", err);
    },
  })
}



/*----------  Toggling the need sevice  ----------*/
toggleDropdown(id:any) {
  this.isDropdownVisible[id] = !this.isDropdownVisible[id];
}


}
